import { render, staticRenderFns } from "./salesorderbyproduct.vue?vue&type=template&id=9559aa54"
import script from "./salesorderbyproduct.vue?vue&type=script&lang=js"
export * from "./salesorderbyproduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports